export enum NewProjectType {
    NewProject = 0,
    FromTemplate = 1
}